import React from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { useWindowSize } from '../Helpers/useWindowSize';
import { formatIsoDate } from '../Helpers/dateFormatter';
import { InputErrorType, DateType } from '../CommonTypes';
import withRequired from './withRequired';

const InputDate = ({
  name,
  value,
  min,
  max,
  handleChange,
  onBlur,
  required,
  errors,
  inline,
  label,
}) => {
  const { width } = useWindowSize();

  const renderInput = (errorMgs) => (
    <React.Fragment>
      <Input
        type="date"
        name={name}
        value={value}
        min={min}
        max={max}
        onChange={handleChange}
        onBlur={onBlur}
        required={required}
        pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
        placeholder={formatIsoDate(new Date())}
        className={errorMgs ? 'is-invalid' : ''}
      />

      <FormFeedback>
        {errorMgs
          ? errorMgs.map((message, k) => (
              <li key={k} style={{ listStyle: 'none' }}>
                {message}
              </li>
            ))
          : ''}
      </FormFeedback>
    </React.Fragment>
  );

  let errorMgs;

  if (errors) {
    errors.details.forEach((error) => {
      if (error.fieldName === name) {
        errorMgs = error.messages;
      }
    });
  }

  return (
    <FormGroup className={errorMgs && 'is-invalid'}>
      <Row className="align-items-center text-start">
        {label ? (
          <Label
            for={name}
            className={
              // eslint-disable-next-line no-nested-ternary
              inline
                ? width > 360
                  ? 'col-6 mb-0 large text-start'
                  : 'col-4 mb-0 large text-start'
                : 'text-start'
            }
          >
            {required ? <sup>*</sup> : ''} {label}
          </Label>
        ) : (
          ''
        )}

        {inline ? (
          <Col xs={width > 360 ? 6 : 8}>{renderInput(errorMgs)}</Col>
        ) : (
          <Col>{renderInput(errorMgs)}</Col>
        )}
      </Row>
    </FormGroup>
  );
};

InputDate.propTypes = {
  errors: InputErrorType,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  value: DateType,
  min: DateType,
  max: DateType,
  validationErrors: PropTypes.object, //eslint-disable-line
  onBlur: PropTypes.func,
  inline: PropTypes.bool,
};

InputDate.defaultProps = {
  errors: undefined,
  label: null,
  required: false,
  value: undefined,
  min: undefined,
  max: undefined,
  onBlur: undefined,
  inline: false,
};

export default withRequired(InputDate);
